<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "Añadir" : "Actualizar" }} Carpeta de trabajo</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">

        <vs-input label="Nombre" v-model="dataName" @input="dataName = $event.toUpperCase()" class="mt-5 w-full" name="item-name" />

        <vx-input-group class="mt-6" v-if="!croppedImg">
          <vs-label class="ml-2">Logo</vs-label>
          <br>
          <img class="center-element" v-if="dataLogoOld" :src="logoOldDecode" alt="logoOld">
          <br>
          <vs-label  v-if="!dataLogoOld">{{ dataLogo ? dataLogo.name : 'No hay un logo seleccionado' }}</vs-label>

          <vs-button class="mt-3"  @click="$refs.fileInputLogo.click()">Seleccionar un Logo</vs-button>
        </vx-input-group>

        <vx-input-group class="mt-6" v-else>
          <vs-label class="ml-2">Logo</vs-label>
          <br>
          <img class="center-element" :src="urlCroppedImg" alt="logoCropped">
          <vs-button class="mt-3" @click="$refs.fileInputLogo.click()">Cambiar Logo</vs-button>
        </vx-input-group>

        <input type="file" ref="fileInputLogo" class="hidden" accept="image/*" @change="processLogo">

      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="isSubmitted">Aceptar</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancelar</vs-button>
    </div>

    <vs-popup :button-close-hidden="true" title="Ajusta tu logo" :active.sync="popupLogoAdjust">
      <cropper-logo v-if="popupLogoAdjust" :close-popup-logo-adjust="closePopupLogoAdjust" :load-img="loadImg" :data-img="dataImg" :set-cropped-img="setCroppedImg" :set-data-img-to-show="setDataImgToShow"></cropper-logo>
    </vs-popup>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import CropperLogo from "@/views/pages/configuration/companies/components/CropperLogo";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    CropperLogo
  },
  data () {
    return {
      popupLogoAdjust: false,
      isSubmitted: false,
      dataId: null,
      dataName: "",
      dataLogo: null,
      dataLogoOld: null,
      dataImg: null,
      loadImg: null,
      croppedImg: null,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const { id, name, logo } = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.dataName = name
        this.dataLogoOld = logo
        this.initValues()
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    logoOldDecode() {
      return "data:image/jpg;base64, " + this.dataLogoOld;
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    selectedCompany() {
      return this.$store.state.account.user.me.selected_company.id;
    },
    urlCroppedImg() {
      return URL.createObjectURL(this.croppedImg);
    }
  },
  methods: {
    initValues () {
      if (this.data.id) {
        this.dataLogo = null
        this.dataImg = null
        this.loadImg = null
        this.croppedImg = null
        return
      }
      this.dataId = null
      this.dataName = ""
      this.dataLogo = null
      this.dataImg = null
      this.loadImg = null
      this.croppedImg = null
      this.dataLogoOld = null
    },
    setDataImgToShow(dataImg) {
      this.dataLogo = dataImg;
    },
    setCroppedImg(croppedImg) {
      this.croppedImg = croppedImg
    },
    closePopupLogoAdjust() {
      this.popupLogoAdjust = false;
    },
    processLogo(event) {
      let file = event.target.files[0];

      const reader = new FileReader()
      reader.onload = e => {
        this.dataImg = file;
        this.loadImg = e.target.result;
        this.popupLogoAdjust = true;
        this.dataLogo = null;
      }
      reader.readAsDataURL(file)

    },
    submitData () {
      this.isSubmitted = true;
      if (this.dataId) {
        this.$store.dispatch('companies/updateCompany', {company: {name: this.dataName, logo: this.croppedImg, id: this.dataId}, aclChangeRole: this.$acl.change})
          .then(() => {
            this.$emit('closeSidebar');
            this.initValues();
            this.isSubmitted = false;
          })
          .catch(() => { this.isSubmitted = false; })
      } else {
        this.$store.dispatch('companies/createCompany', {company: {name: this.dataName, logo: this.croppedImg}})
          .then(() => {
            this.$emit('closeSidebar');
            this.initValues();
            this.isSubmitted = false;
          })
          .catch(() => { this.isSubmitted = false; })
      }
    },
  },
  created() {

  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
